import React from 'react';
import PropTypes from 'prop-types';
import {
  SimpleModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@ami/react/core';
import { Button } from '@ami/react/core';
import { FormInput } from '@ami/react/core';
import { ordersService } from '../../../../orders/ordersService';
import {
  CustomerApproval,
  CustomerApprovalDocument,
} from '../../../../orders/order';
import { DealerUserContactSelection } from './DealerUserContactSelection';
import { dealerUserService } from '../../../../dealer-users/dealerUserService';
import { OrderInput } from '../../../../orders/order';
import { UsersAsyncDropdown } from '../../../../users/UsersAsyncDropdown';
import { FormFileUpload } from '@ami/react/core';
import { DealerBranch } from '../../../../dealer-branches/dealerBranch';
import { DealerUserFilter } from '../../../../dealer-users/dealerUserFilter';
import { Label } from 'reactstrap';

export default class AddCustomerApprovalModal extends React.Component {
  constructor(props) {
    super(props);
    this.updateEntity = this.updateEntity.bind(this);
    this.state = {
      saving: false,
      entity: new CustomerApproval(),
      dealerUsers: [],
      orderEdit: null,
    };
  }

  static propTypes = {
    order: PropTypes.any.isRequired,
    orderLineItem: PropTypes.any.isRequired,
    onChanged: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
  };

  async componentDidMount() {
    const { order, orderLineItem } = this.props;

    const orderEdit = await OrderInput.getForEdit(this.props.order.id);
    const dealerBranch = await DealerBranch.getById(orderEdit.dealerBranchId);
    var dealerUsers = await dealerUserService.search(
      new DealerUserFilter({
        dealerBranchId: dealerBranch.id,
        dealerGroupId: dealerBranch.dealerGroupId,
      })
    );
    var dealerUsersOrder = dealerUsers.filter((x) =>
      x.isAuthorizedForDealerBranch(
        dealerBranch.dealerGroupId,
        orderEdit.dealerBranchId
      )
    );
    this.setState({ orderEdit: orderEdit });
    this.setState({ dealerUsers: dealerUsersOrder });

    this.onUpdateInternal({
      ...this.state.entity,
      dealerContactIds: [orderEdit.dealerContactId],
      relatedId: order.id,
      subRelatedId: orderLineItem.id,
    });
  }

  onUpdateInternal(entity) {
    this.setState({ entity: new CustomerApproval({ ...entity }) });
  }

  updateEntity(e) {
    this.onUpdateInternal({
      ...this.state.entity,
      [e.target.id]: e.target.value,
    });
  }

  handleUsersSelectionChanged = (dealerContactIds) => {
    this.onUpdateInternal({ ...this.state.entity, dealerContactIds });
  };

  onEngineeringTeamLeadChange(id, name) {
    var entity = this.state.entity;
    entity.engineeringTeamLeadId = id;
    entity.engineeringTeamLeadName = name;
    this.onUpdateInternal(entity);
  }

  updateCustomDocument(updateObject) {
    var entity = this.state.entity;

    if (!updateObject.fileName || !updateObject.fileKey) {
      const privateDocuments = [];
      this.onUpdateInternal({ ...this.state.entity, privateDocuments });
    } else {
      const privateDocuments = [
        ...entity.privateDocuments,
        new CustomerApprovalDocument({
          fileKey: updateObject.fileKey,
          fileName: updateObject.fileName,
        }),
      ];

      this.onUpdateInternal({ ...this.state.entity, privateDocuments });
    }
  }

  hide = () => this.props.onHide();

  save = () => {
    this.setState({ saving: true });

    ordersService
      .addCustomerApproval(this.state.entity)
      .then(() => {
        this.props.onChanged();
        this.hide();
        var newEntity = new CustomerApproval();
        this.onUpdateInternal({
          ...newEntity,
          dealerContactIds: [this.state.orderEdit.dealerContactId],
          relatedId: this.props.order.id,
          subRelatedId: this.props.orderLineItem.id,
        });
      })
      .finally(() => this.setState({ saving: false }));
  };

  render() {
    const { entity, dealerUsers } = this.state;
    const { orderLineItem, show, order } = this.props;
    if (!show) return null;
    return (
      <SimpleModal show={show}>
        <ModalHeader title={`Add Customer Approval - Order ${order.name}`} />
        <ModalBody>
          <form className="container">
            <div className="row">
              <div className="col">
                <div className="position-relative form-group">
                  <label className="form-label">Order Line</label>
                  <div>{orderLineItem.name}</div>
                  <div>{orderLineItem.partNumber}</div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="position-relative form-group">
                  <label className="form-label">Approval Name</label>
                  <div className="from-sub-heading">
                    This name will be visible to the end customer
                  </div>
                </div>
                <FormInput
                  id="name"
                  label=""
                  placeholder="Enter the name of this approval"
                  maxLength={50}
                  type="text"
                  className="mb-1"
                  value={entity.name}
                  required
                  onChange={this.updateEntity}
                />
                <div>
                  {dealerUsers.length > 0 && (
                    <DealerUserContactSelection
                      usersIds={entity.dealerContactIds || []}
                      users={dealerUsers}
                      onUpdate={(x) => this.handleUsersSelectionChanged(x)}
                    />
                  )}
                </div>
                <div className="position-relative form-group">
                  <Label className="form-label">Engineering Team Lead</Label>
                  <UsersAsyncDropdown
                    onChange={(user) =>
                      this.onEngineeringTeamLeadChange(
                        user ? user.id : null,
                        user ? user.label : null
                      )
                    }
                    selected={
                      entity.engineeringTeamLeadId
                        ? {
                          id: entity.engineeringTeamLeadId,
                          label: entity.engineeringTeamLeadName,
                        }
                        : null
                    }
                    placeholder={'Select the Engineering Team Lead...'}
                    permission={'CanBeAssignedAsEngineeringTeamLead'}
                    required
                  />
                </div>
                <div className="position-relative  form-group">
                  <label className="form-label">Private Notes</label>
                  <div className="from-sub-heading">
                    These notes will only be visible to AMI users
                  </div>
                </div>
                <FormInput
                  id="privateNote"
                  label=""
                  placeholder="Enter some private notes"
                  maxLength={500}
                  type="textarea"
                  rows={2}
                  value={entity.privateNote}
                  onChange={this.updateEntity}
                />
                <div className="position-relative  form-group">
                  <label className="form-label">Private Documents</label>
                  <div className="from-sub-heading">
                    Add any supporting documentation for this approval (photos,
                    email threads, etc).
                  </div>
                  <div className="from-sub-heading">
                    Additional files can be added later.
                  </div>
                </div>
                <FormFileUpload
                  hideUploadAfterFile={true}
                  onFileUploaded={(fileInfo) =>
                    this.updateCustomDocument({
                      fileKey: fileInfo.key,
                      fileName: fileInfo.name,
                    })
                  }
                >
                  {entity &&
                    entity.privateDocuments.length > 0 &&
                    entity.privateDocuments[0].fileName}
                </FormFileUpload>
              </div>
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-secondary" onClick={this.hide}>
            Cancel
          </button>
          <Button
            label="Save"
            className="btn btn-primary"
            onClick={this.save}
            showSpinner={this.state.saving}
            disabled={this.state.saving}
          />
        </ModalFooter>
      </SimpleModal>
    );
  }
}
